module.exports = __webpack_public_path__ + "static/media/logo.064a5093.png";